export const nutritionConstants = {
    SEARCH_REQUEST: 'NUTRITION_SEARCH_REQUEST',
    SEARCH_SUCCESS: 'NUTRITION_SEARCH_SUCCESS',
    SEARCH_FAILURE: 'NUTRITION_SEARCH_FAILURE',

    GET_REQUEST: 'NUTRITION_GET_REQUEST',
    GET_SUCCESS: 'NUTRITION_GET_SUCCESS',
    GET_FAILURE: 'NUTRITION_GET_FAILURE', 
};